export default "__VITE_ASSET__CA7D$TYF__"